import { AnalyticsBrowser } from '@segment/analytics-next'

const signupWidget = document.getElementById('cd-signup-widget')

const segmentKey = import.meta.env.VITE_SEGMENT_KEY

const segmentEnabled
  = import.meta.env.VITE_SEGMENT_ENABLED === '1'
    && !!segmentKey
    && (signupWidget ? signupWidget.dataset.analytics !== 'false' : true)

export const segmentLoaded = ref(false)

export const analytics = new AnalyticsBrowser()

const loadScript = () => analytics.load({ writeKey: segmentKey })

export async function installSegment() {
  if (segmentEnabled) {
    try {
      await loadScript(segmentKey)
      segmentLoaded.value = true
    }
    catch {
      segmentLoaded.value = false
    }
  }
}

export async function getAnonymousId() {
  const segmentUser = await analytics.user()
  return segmentUser?.anonymousId()
}
